import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  MessageBanner,
  MessageBannerOptions
} from '@com-delta-omnichannel/mach-core-js';
import { PushPipe } from '@ngrx/component';
import { FlyoutStatusTracker } from '../../models/interfaces/status-tracker.interfaces';
import { TrackerComponent } from './components/tracker/tracker.component';

@Component({
  selector: 'idp-flyout-status-tracker',
  standalone: true,
  imports: [CommonModule, TrackerComponent, PushPipe],
  templateUrl: './flyout-status-tracker.component.html',
  styleUrls: ['./flyout-status-tracker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlyoutStatusTrackerComponent implements AfterViewInit {
  @Input() content: FlyoutStatusTracker = {} as FlyoutStatusTracker;
  @Output() analyticsData = new EventEmitter<Event>();
  @Output() errorAnalyticsData = new EventEmitter<string>();

  messageBannerOptions!: MessageBannerOptions;

  messageBannerId = 'flyout-error-message-banner';

  private messageInstance!: MessageBanner;

  ngAfterViewInit() {
    const checkContent = () => {
      if (this.content?.errors?.message) {
        this.initializeMessageBanner();
      } else {
        setTimeout(checkContent, 50);
      }
    };
    checkContent();
  }

  private initializeMessageBanner() {
    this.messageBannerOptions = this.setupMessageBanner();
    this.messageInstance = new MessageBanner(this.messageBannerOptions);
    this.errorAnalyticsData.emit(this.content.errors?.message.title);
  }

  private setupMessageBanner(): MessageBannerOptions {
    return {
      id: `${this.messageBannerId}`,
      type: 'error',
      isSticky: false,
      hasBar: true,
      iconSize: 'small',
      content: {
        header: {
          title: '',
          hasCloseButton: false
        },
        description: this.content.errors?.message.title,
        link: {
          label: this.content.errors?.action.label || '',
          href: this.content.errors?.action.url,
          target: '_blank'
        }
      }
    };
  }
}
